// Data seam for notes and dismissed notices, mirroring src/data/portfolio.js.
//
// Notes and dismissals are org-wide, not per-user: this is one shared
// portfolio, so a note written by one signed-in user is meant for whoever opens
// the page next, and a notice dismissed by one person stays dismissed for
// everybody. Nothing here is keyed by the viewer.

import { request } from './portfolio';

/** Resolves to `{ notes, dismissals }`. */
export const getNotes = () => request('notes');

export const createNote = (body) =>
  request('notes', { method: 'POST', body: JSON.stringify({ body }) });

export const updateNote = (id, body) =>
  request(`notes/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify({ body }),
  });

export const deleteNote = (id) =>
  request(`notes/${encodeURIComponent(id)}`, { method: 'DELETE' });

/**
 * Hides a warning.
 *
 * Sends the notice text, not an id — warnings are regenerated on every fetch
 * and have none. The server hashes it, so if the underlying problem later
 * changes wording the notice surfaces again rather than staying buried.
 */
export const dismissNotice = (notice) =>
  request('notes/dismissals', { method: 'POST', body: JSON.stringify({ notice }) });

export const restoreNotice = (fingerprint) =>
  request(`notes/dismissals/${encodeURIComponent(fingerprint)}`, { method: 'DELETE' });
